import { BESTIARY_PAGES, BESTIARY_TIERS, getBestiaryPage, } from '../data/bestiary.js';
/**
 * The hunting log (ADR 0093), derived from the career and never stored on
 * its own: kills give the tier, the tier gives a title and a sliver of damage.
 */
/** Tiers reached with this many kills: 0 below the first, up to `BESTIARY_TIERS.length`. */
export function bestiaryTier(kills) {
    return BESTIARY_TIERS.filter((tier) => kills >= tier.kills).length;
}
/**
 * What a player's blows against a mob are multiplied by: 1 for a creature
 * without a page or below the first tier, the best tier reached otherwise.
 */
export function bestiaryDamageMultiplier(career, mobId) {
    if (getBestiaryPage(mobId) === undefined)
        return 1;
    const tier = bestiaryTier(career.kills[mobId] ?? 0);
    return 1 + (BESTIARY_TIERS[tier - 1]?.damageBonus ?? 0);
}
/** How many pages stand at `tier` or beyond: the log's titles count them. */
export function pagesAtTier(career, tier) {
    return BESTIARY_PAGES.filter((page) => bestiaryTier(career.kills[page.mob] ?? 0) >= tier).length;
}
/** One page as the window draws it. */
export function bestiaryPageState(career, page) {
    const kills = career.kills[page.mob] ?? 0;
    const tier = bestiaryTier(kills);
    return {
        ...page,
        kills,
        tier,
        next: BESTIARY_TIERS[tier]?.kills ?? null,
        hidden: kills === 0,
        loot: career.lootSeen[page.mob] ?? [],
    };
}
/** The whole log, in the order of `BESTIARY_PAGES`. */
export function bestiaryOf(career) {
    return BESTIARY_PAGES.map((page) => bestiaryPageState(career, page));
}
//# sourceMappingURL=bestiary.js.map